import Table, { ColumnsType } from 'antd/lib/table';
import { DEFAULT_DATE_FORMAT, getTimezoneFormattedTime } from 'src/domain/date/date';
import { PJM_TZ } from 'src/domain/pjm';
import { PjmLocationDto } from 'src/domain/pjm/dto/PjmLocationDto';
import { PjmRegistrationDto } from 'src/domain/pjm/dto/PjmRegistrationDto';

export function LocationRegistrationTable({ value }: { value: PjmLocationDto['registrations'] }) {
    const registrations = value?.length ? value : [];

    const columns: ColumnsType<PjmRegistrationDto> = [
        {
            title: 'Reg ID',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            minWidth: 120,
        },
        {
            title: 'Registration Name',
            dataIndex: ['summaryInfo', 'name'],
            key: 'name',
            minWidth: 200,
        },
        {
            title: 'Program',
            dataIndex: ['summaryInfo', 'program'],
            key: 'program',
        },
        {
            title: 'Status',
            dataIndex: ['summaryInfo', 'status'],
            key: 'status',
        },
        {
            title: 'Effective Date',
            dataIndex: ['summaryInfo', 'startDate'],
            key: 'startDate',
            render: (text, record) => <>{text ? getTimezoneFormattedTime(text, PJM_TZ, DEFAULT_DATE_FORMAT) : ''}</>,
            minWidth: 120,
        },
        {
            title: 'Termination Date',
            dataIndex: ['summaryInfo', 'endDate'],
            key: 'endDate',
            render: (text, record) => <>{text ? getTimezoneFormattedTime(text, PJM_TZ, DEFAULT_DATE_FORMAT) : ''}</>,
            minWidth: 120,
        },
        {
            title: 'LSE',
            dataIndex: ['summaryInfo', 'LSE', 'name'],
            key: 'lseName',
        },
    ];

    return <Table dataSource={registrations} columns={columns} pagination={false} rowKey="uuid" tableLayout={'auto'} scroll={{ x: 'scroll' }} />;
}
